export default __webpack_public_path__ + "static/Theinhardt-Heavy-subset-23a53cab8306eaaca4f2448f8c8f312e.woff2";